import { PlanType, CurrentPlan } from '@dgx-pr-spa/shared/util';
import { OffersType } from '@dgx-pr-spa/shared/util';
import { Offer } from '@dgx-pr-spa/shared/util';
import { Offers } from '@dgx-pr-spa/shared/util';
import { UpsellExclusions } from '@dgx-pr-spa/shared/util';
import { Service, Description } from '@dgx-pr-spa/shared/util';

export const getPricegross = (
  services = [] as Service[],
  description: Description
) => {
  const extra =
    services.length &&
    services.filter(
      (service: Service) => service.description === description
    )[0];
  const priceGross = extra && extra?.charge_customer ? extra?.price_gross : 0;
  return extra ? priceGross : 'Not Offered';
};

export const offersType = (offers: Offers) => {
  return offers?.replacement_offers
    ? offers?.replacement_offers?.length > 1
      ? OffersType.STANDARD
      : OffersType.BESPOKE
    : undefined;
};

export const planType = (currentPlan: CurrentPlan) => {
  return currentPlan?.plan_category === 'M'
    ? PlanType.MULTIPLAN
    : PlanType.SINGLE;
};

export const isUpsellExclusion = (reason) => {
  return UpsellExclusions[reason] !== undefined;
};

export const isUpsellExclusionActive = (offer: Offer) => {
  const upsellReasons = offer?.upsell_reason
    ? offer?.upsell_reason.split(',')
    : [];
  return !!upsellReasons.some(isUpsellExclusion);
};
